import { routes } from "@constants/routes";
import {
  CertificateAndLicenseTable,
  CertificateForm,
  useGetCertificateAndLicenseByIdLazyQuery,
  useResumeStore,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { useGetCertificateAndLicensesQuery } from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export type TCertificateAndLicenseState = "TABLE" | "FORM";

interface ICertificateAndLicenseTabContent {
  handleNextTab: () => void;
}

const CertificateAndLicenseTabContent = ({ handleNextTab }: ICertificateAndLicenseTabContent) => {
  const location = useLocation();
  const [certificateAndLicenseState, setCertificateAndLicenseState] = useState<TCertificateAndLicenseState>("TABLE");
  const { data, refetch, loading } = useGetCertificateAndLicensesQuery();
  const { setCertificateAndLicenseEditId } = useResumeStore();
  const [getCertificateInfoById, { data: certificateInfoByIdData, loading: certificateInfoByIdLoading }] =
    useGetCertificateAndLicenseByIdLazyQuery();

  useEffect(() => {
    setCertificateAndLicenseEditId(undefined);
  }, [setCertificateAndLicenseEditId]);

  return (
    <div>
      {certificateAndLicenseState === "TABLE" ? (
        <CertificateAndLicenseTable
          setCertificateAndLicenseState={setCertificateAndLicenseState}
          certificateAndLicenseState={certificateAndLicenseState}
          handleNextTab={handleNextTab}
          data={data?.me?.certificateandlicenses || []}
          refetch={refetch}
          loading={loading}
          showAddNewSection={true}
        />
      ) : (
        <CertificateForm
          setCertificateAndLicenseState={setCertificateAndLicenseState}
          pathname={location.pathname}
          supportUrl={routes.support.main}
          getCertificateInfoById={getCertificateInfoById}
          certificateInfo={certificateInfoByIdData?.certificateAndLicense?.get}
          getCertificateInfoLoading={certificateInfoByIdLoading}
          userType={UserTypeEnum.USER}
        />
      )}
    </div>
  );
};

export default CertificateAndLicenseTabContent;
